<template>
  <div>
    <hr />
    <h2 class="about__tiles__header">
      Jakie są korzyści z programu<br />
      Geberit Pro?
    </h2>
    <div class="about__tiles">
      <section class="about__tiles__box_section">
        <Box color="box--green">
          <template #header>
            <b>PARTNERSTWO</b>
          </template>
          Otrzymujesz bezpośrednie <b>partnerstwo</b> z firmą Geberit
        </Box>
        <img class="about__tiles__image" src="@/assets/img/about/tiles/partnership.png" alt="about" />
      </section>
      <Box color="box--blue">
        <template #header>
          ATRAKCYJNE
          <b>NAGRODY</b>
        </template>
        Za dokonane zakupy zbierasz punkty i wymieniasz je na nagrody rzeczowe lub finansowe wspierające Twoją pracę
      </Box>

      <!--  -->

      <Box color="box--dark-blue">
        <template #header>
          PAKIET KORZYŚCI <br />
          <b>SPRZĘTOWYCH</b>
        </template>
        Będziesz mógł liczyć na preferencyjny dostęp do wypożyczalni narzędzi Ramirent oraz możliwość zamówienia
        narzędzi na
        nagrody na preferencyjnych warunkach
      </Box>
      <section class="about__tiles__box_section">
        <Box color="box--green">
          <template #header>
            <b>SZKOLENIA</b>
          </template>
          Możliwość wymiany doświadczeń z najlepszymi instalatorami, w ramach organizowanych <b>szkoleń, eventów i
            poprzez
            narzędzia internetowe</b>
        </Box>
        <img class="about__tiles__image" src="@/assets/img/about/tiles/training.png" alt="about" />
      </section>

      <!--  -->

      <section class="about__tiles__box_section">
        <img class="about__tiles__image" src="@/assets/img/about/tiles/promotions.png" alt="about" />
        <Box color="box--blue">
          <template #header>
            DODATKOWE <br />
            <b>AKCJE PROMOCYJNE</b>
          </template>
          Cyklicznie uruchamiamy akcje, które pozwolą Ci zebrać jeszcze więcej punktów i odebrać jeszcze więcej nagród
        </Box>
      </section>
      <Box color="box--green">
        <template #header>
          OSOBISTE KONTO <br />
          <b>NA STRONIE</b>
        </template>
        Dzięki niej jesteś na bieżąco ze wszystkimi aktualnościami Geberit i dowolnie dysponujesz zebranymi punktami
      </Box>

      <!--  -->

      <Box color="box--blue">
        <template #header>
          <b>USŁUGI</b>
        </template>
        Twoje <b>usługi</b> będą polecane na stronie www.geberit.pl
      </Box>
      <section class="about__tiles__box_section">
        <Box color="box--green">
          <template #header>
            CERTYFIKOWANY
            <b>INSTALATOR</b>
          </template>
          Zostań Certyfikowanym Instalatorem Geberit Pro i odbierz jeszcze więcej benefitów: <b>pakiet reklamowy na
            start</b>
          (znakowane ubrania, wizytówki, oklejanie samochodu), <b>dostęp do szerszego katalogu nagród, wsparcie
            prawne</b>.
        </Box>
        <img class="about__tiles__image" src="@/assets/img/about/tiles/installer.png" alt="about" />
      </section>

      <!--  -->

      <section class="about__tiles__box_section about__tiles__box_section--full">
        <img class="about__tiles__image" src="@/assets/img/about/tiles/support.png" alt="about" />
        <Box color="box--dark-blue">
          <template #header>
            DEDYKOWANA OSOBA&nbsp;DO <br />
            <b>EKSPRESOWEGO WSPARCIA</b>
          </template>
          Na co dzień Twoim kontem będzie opiekował Koordynator Programu, który przypomni Ci o specjalnych akcjach
          promocyjnych, terminach zgłaszania zakupów, przepadających punktach. Pomoże Ci też policzyć i zarejestrować
          dokonane
          zakupy lub zamówić nagrody
        </Box>
      </section>
    </div>
  </div>
</template>

<script>
import Box from './Box.vue'

export default {
  name: 'Tiles',
  components: {
    Box
  }
}
</script>



// WEBPACK FOOTER //
// src/app/about/Tiles.vue